import { fetchFalckdkApi } from '../utils/fetch';

/**
 * @param {string} plateNumber
 */
export async function fetchCarPlate(plateNumber) {
    return fetchFalckdkApi('/api/Cars/FindPlate', {
        method: 'GET',
        params: {
            plate: plateNumber,
        },
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    });
}
